angular.module('mavibayrak')
  .controller('MarinaCtrl', function ($scope, $stateParams, $state, $ionicPopup, $ionicHistory, Marinas, Cities, Towns, Audits, Utils) {
    var audit, action = 'update';

    // Edit
    if ($stateParams.auditId) {
      audit = Audits.getStored($stateParams.auditId);
      if (!audit) {
        $ionicHistory.nextViewOptions({historyRoot: true});
        $ionicPopup.alert({ template: 'Kayıt bulunamadı. id: ' + $stateParams.auditId})
          .then(function () { $state.go('tab.marinas'); });
        return;
      }
    // New
    } else {
      // Tek draft kayıt saklanır, onu alalım
      audit = Audits.getDraft('marina');
      // Kayıtlı draft varsa ve farklı bir marinaya aitse silelim
      if (audit && audit.marina.id != $stateParams.marinaId) {
        Audits.deleteUnsavedData('marina');
        audit = null;
      }
      // Kayıtlı draft yoksa ya da önceki adımda sildiysek default data'ları oluşturalım
      if (!audit) {
        audit = Audits.newRecord();
        audit.marina = Marinas.get($stateParams.marinaId);
        action = 'insert';
      }
    }

    // Convert created_at to date object.
    // toISOString timezone verisi içermez, ekleyelim
    var date = new Date(audit.audit.created_at);
    audit.audit.created_at = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));

    $scope.audit = audit.audit;
    $scope.marina = audit.marina;
    $scope.city = Cities.get($scope.marina.city_id);
    $scope.town = Towns.get($scope.marina.town_id);
    $scope.methods = Audits.methods;
    $scope.types = Audits.types;

    $scope.gotoQuestions = function () {
      if (action == 'insert') {
        Audits.insert(audit);
      } else {
        Audits.update(audit.id, {
          audit: $scope.audit,
          marina: $scope.marina
        });
      }
      $state.go('tab.questions_marina', {auditId: audit.id, page: 1});
    };

    $scope.cancelAudit = function () {
      Utils.cancelAudit(audit);
    };
  });